import ChipColors from './ChipColors';

export default [
  {
    value: 'NotStarted',
    text: 'Não iniciado',
    ...ChipColors.neutral,
  },
  {
    value: 'InformedBusinessData',
    text: 'Informado dados da loja',
    ...ChipColors.warning,
  },
  {
    value: 'InformedBusinessAddress',
    text: 'Informado endereço da loja',
    ...ChipColors.warning,
  },
  {
    value: 'InformedPin',
    text: 'Informado PIN',
    ...ChipColors.warning,
  },
  {
    value: 'InformedDocumentFront',
    text: 'Informado Frente do documento',
    ...ChipColors.warning,
  },
  {
    value: 'InformedDocumentBack',
    text: 'Informado verso do documento',
    ...ChipColors.warning,
  },
  {
    value: 'ConfirmedDocument',
    text: 'Documento confirmado',
    ...ChipColors.success,
  },
  {
    value: 'InformedSelfie',
    text: 'Informado Selfie',
    ...ChipColors.wait,
  },
];
